import React from 'react'
import { Heading, Link, Page } from '@shopify/polaris'

const Index = () => {
  return (
    <Page>
      <Heading>Arctic Blue Inventory Management</Heading>
      <nav>
        <Link url="/bull-ui">Jobs Dashboard</Link>
        <Link url={`/diamonds`}>Diamonds</Link>
      </nav>
    </Page>
  )
}

export default Index
